import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface RosterFilterEmptyStateProps {
  search: string;
  activeFilterCount: number;
  onClear: () => void;
}

export const RosterFilterEmptyState = ({
  search,
  activeFilterCount,
  onClear,
}: RosterFilterEmptyStateProps) => {
  const trimmedSearch = search.trim();
  const searching = trimmedSearch.length > 0;
  const content =
    searching && activeFilterCount > 0
      ? {
          title: "No people match your search and filters",
          hint: "Try a different name, or widen one of the field filters.",
          action: "Clear search and filters",
        }
      : searching
        ? {
            title: `No people match “${trimmedSearch}”`,
            hint: "Search matches a person's name or their ServiceTitan ID.",
            action: "Clear search",
          }
        : {
            title: "No people match these filters",
            hint: "The filters overlap on nobody — widen or remove one.",
            action:
              activeFilterCount === 1 ? "Clear the filter" : "Clear filters",
          };

  return (
    <Stack
      align="center"
      justify="center"
      gap="sm"
      className="min-h-0 w-full flex-1 border-t border-stroke-tertiary px-6 text-center"
    >
      <Typography variant="subtitleW1">{content.title}</Typography>
      <Typography textColor="secondary">{content.hint}</Typography>
      <Button type="button" size="sm" variant="secondary" onClick={onClear}>
        {content.action}
      </Button>
    </Stack>
  );
};
